module.exports = "/_next/static/images/logo-031f31de02a462a638d76a5f8118aa6b.svg";